// PrivateRoute.jsx
import React, { useEffect } from "react";
import { APP_PATHS } from '../utils/appPaths.js';
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../_helper/Auth/AuthProvider";
import { normalizeUserRole, roleMatches } from "../Layout/Sidebar/Menu";
import Error403 from "../Components/Pages/ErrorPages/ErrorPage403";
import Loader from "../Layout/Loader";

const PrivateRoute = ({ roles }) => {
  const { authenticated, userData, loading } = useAuth();
  const location = useLocation();
  useEffect(() => {
    localStorage.setItem("authenticated", JSON.stringify(authenticated));
  }, [authenticated]);

  if (loading) {
    return <Loader />;
  }

  if (!authenticated) {
    return <Navigate to={APP_PATHS.login} replace state={{ from: location }} />;
  }

  if (!normalizeUserRole(userData?.role)) {
    return <Error403 />;
  }

  if (roles && roles.length > 0) {
    if (!roleMatches(userData?.role, roles)) {
       localStorage.setItem("userDataRole", JSON.stringify(userData?.role));
       return <Error403 />;
    }
  }

  return <Outlet />;
};

export default PrivateRoute;